import { AdminMenuItem } from '../admin/adminMenu';

export const managerMenuItems: AdminMenuItem[] = [
  { label: 'Team Approvals', path: '/manager/dashboard', icon: '☑' },
  { label: 'Trips', path: '/manager/trips', icon: '✈' },
  { label: 'Expense History & Status', path: '/manager/history', icon: '▦' },
  { label: 'Upload Invoice', path: '/manager/invoices', icon: '⇪' },
  { label: 'Reimbursement Status', path: '/manager/history', icon: '₹' },
  { label: 'Add Expense', path: '/manager/expenses/new', icon: '＋' },
];
